import { useSelector } from 'react-redux';

import selectSupport from '~/components/support/ducks/selectors';

export const useSetProactiveChatReason = () => {
	const support = useSelector(selectSupport);

	return reason => {
		if (support?.ada) {
			window?.adaEmbed?.setMetaFields({
				proactiveChatReason: reason
			});
		}
	};
};
